export default __webpack_public_path__ + "static/media/ActionButtons/ComputerBtn.webp";